import React from 'react';
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {SelectV2} from "../forms/FormEl";

const PfFormSelect = React.forwardRef((props, ref) => {

  const {data, loading} = useFetch2(Apis.PROD + '/pdf/list', []);

  return (
    <>
      {
        !loading ?
          <SelectV2 ref={ref} options={data.map(item=>({id: item.codigo,name: item.titulo}))} {...props}/>
          :
          <SelectV2 disabled options={[{id: 0, name: 'Cargando...'}]}/>
      }
    </>
  )
})

export default PfFormSelect;
